<template>
  <div class="article_details">
    <div class="content">
      <div class="data_detail" v-for="item in passData" :key="item.id">
        <div class="top_title">
          <div class="title text_one_line" :title="item.title">
            {{ item.title }}
          </div>
          <div @click="goBack" class="go_back">
            <div class="back_txt">Back</div>
          </div>
        </div>

        <div class="other_infor">
          <span class="time">{{ item.publish }}</span>
          <span class="author">Author:{{ item.author }}</span>
          <span class="source">Source:{{ item.source }}</span>
        </div>
        <div class="abstract">{{ item.summary }}</div>
        <div class="detail_txt">
          <div class="paragraph" v-html="item.content">{{ item.content }}</div>
        </div>
        <div class="audit">
          <ul>
            <li
              v-for="(item, key) in auditList"
              :key="key"
              @click="audit(item)"
              :class="{ active: active == item }"
            >
              <span>{{ key }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  newsDetail,
  getEmotionalList,
  updateEmoStatus,
} from "@/common/js/http/version3Api.js";
import qs from "qs";

export default {
  name: "ArticleDetails",
  mounted() {
    this.articleId = this.$route.query.detailId;
    this.getNewsDetail();
    this.getEemoList();
  },
  data() {
    return {
      articleId: 0,
      // passData: {
      //   newsTitle:
      //     "Henan set up a second-phase fund for migrant workers returning to the countryside to support start-up enterprises",
      //   newsTime: "2019-08-21 15:26:23",
      //   newsAuthor: "Li Wenzhe",
      //   newsSource: "Xinhua News Agency",
      //   newsAbstract:
      //     "Abstract: In order to further solve the problem of financing difficulties and financing for migrant workers returning to their hometowns, the Henan Provincial Department of Finance recently set up a second-phase fund for migrant workers returning to their hometowns, and clarified that the fund supports the proportion of start-up enterprises, and compliance with laws and regulations ensures the safety of funds. Under the premise, invest as much as possible in start-up SMEs.",
      //   newsTxt: [
      //     `Xinhua News Agency, Zhengzhou, August 21st (Reporter Li Wenzhe) In order to further solve the problem of financing difficulties and financing for migrant workers returning to their hometowns, the Henan Provincial Department of Finance recently set up a second-phase fund for migrant workers to return to their hometowns, and clearly defined the fund to support start-up enterprises. Proportion, under the premise of legal compliance and ensuring the safety of the fund, invest as much as possible in the start-up SMEs.`,
      //     `According to reports, the second phase of the fund will expand the benefits through three “cooperations”: First, cooperate with the returning township demonstration county and city, encourage the city and county governments to cooperate with the parent fund to set up sub-funds, enlarge the fund scale, and expand the fund investment coverage; It is in cooperation with the returning migrant workers' entrepreneurial demonstration park. The demonstration parks select high-quality enterprises in the park, and the funds and parks jointly give priority support. Third, cooperate with financial institutions to establish a microfinance and investment mechanism with banks, and approve the banks. In the case of start-up enterprises that meet the support policies for migrant workers returning to their hometowns, the fund will carry out low-cost investment.`,
      //     `At the end of 2017, Henan Province set up provincial-level migrant workers to return to the township venture capital fund. The initial investment scale was 5 billion yuan, of which the provincial finance funded 500 million yuan, driving social capital of 4.5 billion yuan. Up to now, there have been 20 investment projects with an investment amount of 4.89 billion yuan, which has fully played the role of “four or two”. The relevant person in charge of the Henan Provincial Department of Finance said that in the future, the fund will continue to optimize the direction of fund investment, and promote the fund to play a more active supporting role to help rural revitalization.`,
      //     `Editor in charge: Gu Wenli`
      //   ]
      // }
      passData: [],
      auditList: {},
      active: "",
    };
  },
  methods: {
    async getEemoList() {
      const { result } = await getEmotionalList();
      this.auditList = result;
    },

    async audit(status) {
      this.active = status;
      const data = {
        id: this.$route.query.detailId,
        status,
        brandToken: localStorage.getItem("brand-token"),
      };
      await updateEmoStatus(qs.stringify(data));
      this.$message({
        message: "审核成功!",
        type: "success",
      });
      // this.getNewsDetail();
    },

    goBack() {
      this.$router.push({
        name: "NewsInformation",
        query: {
          id: sessionStorage.getItem("id"),
          pageName: this.$route.query.pageName,
        },
      });
      // this.$router.replace({
      //   name: "NewsInformation",
      //   query: {
      //     id: sessionStorage.getItem('id')
      //   }
      // });
      //this.$router.push({path:'Deatil'})
    },
    async getNewsDetail() {
      let data = {
        id: this.$route.query.detailId,
      };
      let res = await newsDetail(data);
      if (res.code == 200) {
        this.passData = res.result;

        this.active = res.result[0].emotionalState;
      }
    },
  },
  watch: {
    articleId() {},
  },
};
</script>

<style scoped>
.go_back {
  cursor: pointer;
  padding: 0 15px;
  height: 65px;
  line-height: 65px;
  background: #fff;
}
.back_txt {
  width: 60px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  color: #8590a6;
  text-align: center;
  background: #f2f3f4;
  border: 1px solid rgba(0, 0, 0, 0);
}
.content {
  background: #eff0f1;
  /* padding: 15px; */
}
.data_detail {
  background: #fff;
  padding: 24px;
}
.content .title {
  font-size: 20px;
  color: #4e5671;
  font-weight: bold;
}
.other_infor {
  font-size: 12px;
  color: #80828d;
  margin: 16px 0;
}
.other_infor span {
  margin-right: 20px;
}
.abstract {
  padding: 18px 34px;
  font-size: 14px;
  color: #4f5362;
  text-align: justify;
  line-height: 21px;
  background: #e8eaef;
  margin-bottom: 16px;
}
.paragraph {
  font-size: 18px;
  color: #4e5671;
  text-align: justify;
  line-height: 26px;
  margin-bottom: 30px;
  text-indent: 2em;
}
.audit li {
  position: relative;
  display: inline-block;
  border: 1px solid #c0c0f5;
  /* padding: 30px; */
  border-radius: 50%;
  margin-right: 20px;
  height: 80px;
  width: 80px;
  cursor: pointer;
}
.audit ul {
  text-align: center;
}
.audit span {
  position: absolute;
  font-size: 13px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.active {
  background: #9090e2;
  color: #ffffff;
}
.top_title {
  width: 100%;
  display: flex;
}
.top_title .title {
  width: 95%;
  background: #fff;
  word-break: break-all;
}
.top_title .back {
  margin: 0 auto;
  width: 60px;
  height: 30px;
  color: rgba(133, 144, 166, 1);
  background: rgba(242, 243, 244, 1);
  border-radius: 20px;
}
</style>
